import type { SxProps, Theme } from '@mui/material';

/** Wrapper for the first consultant avatar; overflow visible so the +N badge can sit outside the circle. */
export const consultantCellAvatarWrapperSx: SxProps<Theme> = {
  position: 'relative',
  width: 28,
  height: 28,
  flexShrink: 0,
  overflow: 'visible',
};

/** Pill badge showing how many additional consultants are selected (e.g. +2). */
export const consultantCellExtraCountBadgeSx: SxProps<Theme> = {
  position: 'absolute',
  bottom: -3,
  right: -3,
  minWidth: 18,
  height: 16,
  px: 0.35,
  borderRadius: 999,
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  fontSize: '0.58rem',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
  border: '1.5px solid',
  borderColor: 'background.paper',
  boxSizing: 'border-box',
};

export const consultantCellUpdatingAvatarProgressSx: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  color: 'primary.main',
};
